import { render, staticRenderFns } from "./KleineArticles.vue?vue&type=template&id=6a355220&"
import script from "./KleineArticles.vue?vue&type=script&lang=ts&"
export * from "./KleineArticles.vue?vue&type=script&lang=ts&"
import style0 from "./KleineArticles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports